import { MessageSquare, Settings, User, Pin, CircleDashed } from "lucide-react";

// 02.7-settings.md paso c -- adelgazamiento de WhatsPanel.jsx. Puramente presentacional: la barra
// persistente de arriba (Mensajes/Configuración/Perfil/Fijar).
export default function WhatsPanelTopBar({
  showSettings, onShowMessages, onShowSettings,
  selectedChat, activeRightPanel, onOpenProfile,
  isPinned, onTogglePinned, onShowStories
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "7px 15px 0 15px",
        marginBottom: "8px",
      }}
    >
      <div style={{ display: "flex", gap: "var(--space-2)" }}>
        <button
          onClick={onShowMessages}
          style={{
            background: !showSettings && selectedChat?.chat_jid !== "status@broadcast" ? "#e2e8f0" : "transparent",
            border: "none",
            padding: "6px",
            borderRadius: "50%",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          title="Mensajes"
        >
          <MessageSquare size={18} color={!showSettings && selectedChat?.chat_jid !== "status@broadcast" ? "#111" : "#888"} />
        </button>
        <button
          onClick={onShowSettings}
          style={{
            background: showSettings ? "#e2e8f0" : "transparent",
            border: "none",
            padding: "6px",
            borderRadius: "50%",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          title="Configuración"
        >
          <Settings size={18} color={showSettings ? "#111" : "#888"} />
        </button>
        <button
          onClick={onShowStories}
          style={{
            background: selectedChat?.chat_jid === "status@broadcast" ? "#e2e8f0" : "transparent",
            border: "none",
            padding: "6px",
            borderRadius: "50%",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          title="Historias"
        >
          <CircleDashed size={18} color={selectedChat?.chat_jid === "status@broadcast" ? "#1fa855" : "#888"} />
        </button>
        {selectedChat && (
          <button
            onClick={onOpenProfile}
            style={{
              background: activeRightPanel?.id === "user" ? "#000" : "#222",
              border: "none",
              padding: "6px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              marginLeft: "var(--space-1)"
            }}
            title="Perfil del Usuario"
          >
            <User size={18} />
          </button>
        )}
      </div>
      <button
        onClick={onTogglePinned}
        style={{
          background: isPinned ? "#e2e8f0" : "transparent",
          border: "none",
          padding: "6px",
          borderRadius: "50%",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        title={isPinned ? "Desfijar panel" : "Fijar panel"}
      >
        <Pin size={18} color={isPinned ? "#1fa855" : "#888"} />
      </button>
    </div>
  );
}
